import { render, staticRenderFns } from "./ReportTabs.vue?vue&type=template&id=6ff34c8f&"
import script from "./ReportTabs.vue?vue&type=script&lang=ts&"
export * from "./ReportTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTabs,QTab,QTabPanels,QTabPanel} from 'quasar'
component.options.components = Object.assign({QTabs,QTab,QTabPanels,QTabPanel}, component.options.components || {})
